import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TaskAndAttention } from '../models/taskAndAttention';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class MyAttentionService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  getAttentions(): Observable<TaskAndAttention[]> {
    return this.http.get<TaskAndAttention[]>(`${this.configService.getConfiguration().apiHost}/api/myAttentions`);
  }
}
